import { PROCESS_STEPS } from "@/data/content";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#F5F5F7] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-20">
          <div className="eyebrow">Our Process</div>
          <h2 className="font-serif-display mt-4 text-4xl md:text-6xl leading-[1.05] tracking-tight text-[#111]">
            Effortless from <span className="italic text-[#C8A44D]">start</span> to finish.
          </h2>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6">
          {/* connecting line */}
          <div className="hidden md:block absolute top-[34px] left-[8%] right-[8%] h-px bg-[#111]/15" />

          {PROCESS_STEPS.map((step, i) => (
            <li
              key={step.n}
              data-testid={`process-step-${i}`}
              className="relative"
            >
              <div className="flex items-center gap-4">
                <span className="relative z-10 w-[18px] h-[18px] rounded-full bg-[#C8A44D] ring-8 ring-[#F5F5F7]" />
                <span className="text-xs tracking-[0.32em] uppercase text-[#888]">
                  Step {step.n}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl mt-6 tracking-tight text-[#111]">
                {step.title}
              </h3>
              <p className="mt-3 text-[#555] font-light leading-relaxed text-sm md:text-base max-w-xs">
                {step.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
